// Assets
import languagePack from "../assets/languages/languagePack";

const DEFAULT_LANGUAGE = "hu";

export function translate(language, keyPath) {
  const selectedLang = languagePack[language] ? language : DEFAULT_LANGUAGE;

  const keys = keyPath.split('.');
  let value = languagePack[selectedLang];

  for (let key of keys) {
    if (value && Object.prototype.hasOwnProperty.call(value, key)) {
      value = value[key];
    } else {
      return `Missing translation: ${keyPath}`;
    }
  }

  return value;
}
